import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { QestlabListDropdown } from 'Components/List';
import ListType from 'Components/List/QestlabListDropdown/ListType';
import { valueOrDefault } from 'Lib/Any';
import { FormatTypes } from 'Lib/Format';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { ICoreFieldProps } from './types';

let StabilizedMaterial: React.FC<ICoreFieldProps> = ({
  createWorksheetSelector,
  editable = false,
  visible = true,
  appendNamePrefix = '',
}) => {
  const stabiliserUsed = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.StabiliserUsed`), valueOrDefault(false))
  );

  const stabiliserType = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.StabiliserType`), (x) => x?.Label)
  );

  if (!visible) {
    return null;
  }

  return (
    <NamePrefixModifier appendNamePrefix={appendNamePrefix}>
      {editable ? (
        <>
          <Field input={<Checkbox />} name="StabiliserUsed" />
          {stabiliserUsed && (
            <>
              <Field
                input={<QestlabListDropdown />}
                name="StabiliserType"
                listType={ListType.AdditiveMaterialTypeName}
              />
              <Field input={<NumericInput />} name="StabiliserAmount" />
            </>
          )}
        </>
      ) : (
        <>
          <Field input={<TextOutput />} name="StabiliserUsed" format={{ type: FormatTypes.YesNo }} />
          {stabiliserUsed && (
            <>
              <Field input={<TextOutput />} name="StabiliserType" value={stabiliserType} />
              <Field input={<TextOutput />} name="StabiliserAmount" />
            </>
          )}
        </>
      )}
    </NamePrefixModifier>
  );
};

StabilizedMaterial = withInjectedProps(StabilizedMaterial);

export { StabilizedMaterial };
